<template>
    <div class="tile-content tile-content-secondary">
        <div class="grid-content">
            <div class="grid-item grid-item-full">
                <p>The time to live (TTL) defines the amount of time until the blacklist expires, in seconds. If the
                    value
                    entered is 0 or left empty, it will never expire. Otherwise, the minimum required value is 30
                    seconds.</p>
            </div>
            <div class="grid-item grid-item-half grid-item-break-half">
                <div class="field" :class="{'is-error': false}">
                    <label class="field-label">Select Blacklist Type</label>
                    <div class="field-control has-icon-right">
                        <select class="field-input" v-model="action.type" @change="updateType">
                            <option
                                v-for="type in blacklistTypes"
                                :value="type.value">{{type.label | unCamelCase}}
                            </option>
                        </select>
                        <v-icon icon="caret-down"/>
                    </div>
                </div>
            </div>
            <div class="grid-item grid-item-full">
                <v-checkbox
                    :value="true"
                    v-model="isNeverExpiring"
                    @input="toggleExpiry"
                    label="Never expires"
                    caption="When enabled the blacklist item will be permanent."/>
            </div>
            <div class="grid-item grid-item-half grid-item-break-half" v-if="!isNeverExpiring">
                <r-input
                    :value="action.ttl"
                    @input="updateTtl"
                    :validate="$v.action.ttl"
                    label="Duration (seconds)"
                    help-text="Define the duration of the blacklist item in seconds."/>
            </div>
        </div>
    </div>
</template>

<script>
    import BlacklistActionModel from '@/common/models/rules/actions/blacklist-action-model';
    import {vIcon, vCheckbox} from '@/components/form';
    import {numeric, minValue} from 'vuelidate/lib/validators';
    import _ from '@/common/helpers';
    import BaseAction from '../base-action';

    export default {
        name: 'blacklist',
        extends: BaseAction,
        components: {vIcon, vCheckbox},
        computed: {
            blacklistTypes() {
                return Object.keys(BlacklistActionModel.Types)
                    .map(type => ({label: type, value: BlacklistActionModel.Types[type]}));
            },
        },
        data() {
            return {
                isNeverExpiring: _.isBlank(this.action.ttl)
                    ? true
                    : this.action.ttl === 0,
            };
        },
        validations: {
            action: {
                ttl: {
                    numeric,
                    minValue: (v) => {
                        if (Number(v) === 0) {
                            return true;
                        }
                        return minValue(30)(v);
                    },
                },
            },
        },
        methods: {
            updateTtl(ttl) {
                this.$emit('input', this.action.cloneSelf({ttl}));
            },
            updateType({target}) {
                this.$emit('input', this.action.cloneSelf({type: target.value}));
            },
            toggleExpiry(neverExpires) {
                if (neverExpires) {
                    // reset to zero when not expiring
                    this.updateTtl(0);
                } else {
                    // use the default value otherwise
                    this.updateTtl(30);
                }
            },
            getValidationAggregate() {
                return {
                    name: 'blacklist',
                    rules: [
                        {
                            name: 'Blacklist duration must be numeric.',
                            delegate: () => {
                                this.$v.$touch();
                                return !this.$v.action.ttl.numeric;
                            },
                        },
                        {
                            name: 'Blacklist duration must be at least 30 seconds long.',
                            delegate: () => {
                                this.$v.$touch();
                                return !this.$v.action.ttl.minValue;
                            },
                        },
                    ],
                };
            },
        },
    };
</script>

<style scoped>

</style>
